import { useRouteRefParams } from '@backstage/frontend-plugin-api';
import { entityRouteRef } from '@backstage/plugin-catalog-react';
import { InsightsTab } from '../CatalogTabs';
import { InsightsContextProvider } from '../Providers';

export const AccountInsightsTab = () => {
  const { name } = useRouteRefParams(entityRouteRef);

  return (
    <InsightsContextProvider entityName={name}>
      <InsightsTab />
    </InsightsContextProvider>
  );
};
